import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWithError } from "../utils/fetchWithError.ts";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export const RequireAuth = ({ children }: { children: React.ReactNode }) => {
    const [checking, setChecking] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    
    useEffect(() => {
        fetchWithError("/session", { credentials: "include" })
            .then((result) => {
                if(result.session) {
                    setIsLoggedIn(true);
                    setChecking(false);
                } else {
                    setIsLoggedIn(false);
                    setChecking(false);
                    navigate("/app/login", { replace: true });
                }
            })
            .catch(() => {
                setIsLoggedIn(false);
                setChecking(false);
                navigate("/app/login", { replace: true });
            });
    }, [navigate]);

    if (checking) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
                <CircularProgress />
            </Box>
        );
    }
    if (!isLoggedIn) return null;
    return <>{children}</>;
}; 